import React, { FC } from 'react';

import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { getDesignToken, primitive } from 'styles/constants';
/** Basic inline wrapper to contain a list of items */
type ColorType = 'primary' | 'secondary' | 'inverted';

const colors = {
  primary: primitive.$fieryRed,
  secondary: getDesignToken('color-secondary'),
  inverted: primitive.$mayoEggWhite,
};

const getColor = (color: ColorType) => {
  return colors[color];
};

const DOT_SIZE = 12;

interface IProgressDotsProps {
  /** How many dots shot up */
  dotCount: number;
  /** The color of the active dot
   *
   *  default 'primary'
   */
  color?: ColorType;
  /** in index of the currently active dot */
  activeDotIndex: number;
}

/**
 * Displays a dot(circle) based stepped progress indicator
 */
export const ProgressDots: FC<React.PropsWithChildren<IProgressDotsProps>> = ({
  dotCount = 4,
  activeDotIndex = 0,
  color = 'primary',
}) => {
  const dots = Array.from(Array(dotCount).keys());

  return (
    <Box style={styles.wrapper}>
      {dots.map(dotIndex => (
        <Box
          key={dotIndex}
          style={[
            styles.dot,
            {
              backgroundColor:
                dotIndex === activeDotIndex
                  ? getColor(color)
                  : getDesignToken('border-color-disabled'),
              marginRight: dotIndex + 1 === dotCount ? 0 : DOT_SIZE,
              width: dotIndex === activeDotIndex ? 24 : DOT_SIZE,
            },
          ]}
        />
      ))}
    </Box>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    alignItems: 'center',
    bottom: 8,
    flexDirection: 'row',
    justifyContent: 'center',
    position: 'absolute',
    width: '100%',
  },
  dot: { borderRadius: 50, height: DOT_SIZE },
});
